import Hidden from '@mui/material/Hidden'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { upperFirstLetter } from '../../../utils/misc'
import { SCROLL_TOP_BUTTON_ID } from '@components/Misc/ScrollBtn'
import MenuAccount from '@components/Header/Menu/MenuAccount'
import Divider from '@mui/material/Divider'
import { Button } from '@mui/material'
import { Link } from 'react-router-dom'
import Slide from '@mui/material/Slide'
import makeStyles from '@mui/styles/makeStyles'
import { buttonClasses } from '@mui/material/Button'
import MobileMenuAccountLvl2 from '@components/Header/Menu/MobileMenuAccountLvl2'

const useStyles = makeStyles(() => ({
  button: {
    [`&.${buttonClasses.root}`]: {
      justifyContent: 'space-between',
      height: 50,
      padding: '0 0 0 24px',
      fontWeight: 700,
      fontSize: 16,
      textTransform: 'initial',
    },
  },
}))

const MobileMenu: React.FC<{ links: { url: string; title: string }[] }> = ({ links }) => {
  const classes = useStyles()
  const [isActiveMobileMenu, setIsActiveMobileMenu] = useState(false)
  const { pathname } = useLocation()
  const [activeMenuAccount, setActiveMenuAccount] = useState(false)

  useEffect(() => {
    const el = document.getElementById(SCROLL_TOP_BUTTON_ID)
    if (isActiveMobileMenu && el) {
      el.style.display = 'none'
    } else if (!isActiveMobileMenu && el) {
      el.style.display = 'flex'
    }
  }, [isActiveMobileMenu])

  useEffect(() => {
    setIsActiveMobileMenu(false)
  }, [pathname])

  const onClickLink = () => {
    onCloseMobilePanel()
  }
  const onCloseMobilePanel = () => {
    setIsActiveMobileMenu(false)
  }

  const onOpenMobilePanel = () => {
    setIsActiveMobileMenu(true)
  }

  return (
    <Hidden mdUp>
      <div
        id='nav-icon'
        style={{ width: 30 }}
        className={isActiveMobileMenu ? 'open' : ''}
        onClick={e => {
          setIsActiveMobileMenu(prev => !prev)
        }}
      >
        <span />
        <span />
        <span />
        <span />
      </div>
      <SwipeableDrawer
        PaperProps={{
          className: 'w-320 max-w-full overflow-visible',
          style: { overflow: 'visible' },
        }}
        disableSwipeToOpen={isActiveMobileMenu}
        anchor='left'
        style={{ zIndex: 20 }}
        open={isActiveMobileMenu}
        onOpen={onOpenMobilePanel}
        onClose={onCloseMobilePanel}
      >
        <div className='flex flex-col h-full overflow-auto pt-100 pb-20'>
          {!activeMenuAccount && (
            <Slide direction={'right'} in mountOnEnter unmountOnExit>
              <div>
                <MenuAccount setIsActiveAccount={setActiveMenuAccount} />
                <Divider />
                <ul className='py-10 px-0 list-none overflow-auto'>
                  {links.map(node => {
                    return (
                      <li key={node.title} className='flex items-center justify-between'>
                        <Button
                          className={classes.button}
                          aria-label={node.title}
                          onClick={onClickLink}
                          to={node.url}
                          component={Link}
                          variant='text'
                          disableRipple
                          fullWidth
                        >
                          <span className='text-left'>{upperFirstLetter(node.title)}</span>
                        </Button>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </Slide>
          )}
          <Slide direction='left' in={activeMenuAccount} mountOnEnter unmountOnExit>
            <div>
              <MobileMenuAccountLvl2 goBack={() => setActiveMenuAccount(false)} onClickLink={onClickLink} />
            </div>
          </Slide>
        </div>
      </SwipeableDrawer>
    </Hidden>
  )
}

export default React.memo(MobileMenu)
